var module;
// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/

var is_node = typeof module == 'object' && module.exports;
if (is_node) ;else ;
define(['react', '/www/hola/pub/context.js', '/www/hola/pub/util.js', '/www/hola/pub/support/support'], (React, context, www_util, {
  Support_container
}) => {
  var E = {};
  var App_context = context.App_context;
  var useEffect = React.useEffect,
    useContext = React.useContext,
    Fragment = React.Fragment;
  var Root = function Services() {
    var _useContext = useContext(App_context),
      user = _useContext.user;
    useEffect(() => {
      return void www_util.perr_www_visit({
        id: 'www_support_visit',
        user
      });
    }, []);
    return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "container-fluid hola_support-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement(Support_container, null))));
  };
  E = {
    Root
  };
  return E;
});